export default __webpack_public_path__ + "static/media/hero-background.5fe8bc83.png";